<template>
  <draggable tag="div"
             class="v-gallery"
             :class="{ 'v-gallery--has-any-selected': !!selected }"
             v-bind="{ group: 'groups', draggable: isDraggable, delay: 400, delayOnTouchOnly: true, touchStartThreshold: 3, fallbackTolerance: 3, filter: selectorIsFiltered }"
             v-model="dataCollection"
             @update="$emit('reorder-group', dataCollection.map(i => i.id), galleryMemberId); $emit('reorder', reorder())">
    <div class="v-gallery__group v-gallery__group-item" v-for="group in dataCollection" :key="group.id">
      <div>
        <div class="v-gallery__tools" v-if="toolbar">
          <a class="add-facility" @click="toggleAddForm(group.id)" v-if="addForm" :id="group.id" style="cursor:pointer;">
            <i class="material-icons">add_circle_outline</i>
          </a>
          <a @click="toggleToolbar(group.id)" style="cursor:pointer;" v-if="editButton">
            <img style="vertical-align: top;" src="/images/cms_wijzigen.png">
          </a>
          <a @click="$emit('delete-group', group.id, galleryMemberId)" style="cursor:pointer;" v-if="removeButton">
            <img style="vertical-align: top;" src="/images/cms_verwijderen.png">
          </a>
          <slot name="extra" :group="group"></slot>
        </div>
        <slot name="header" :group="group">
          <h3 class="v-gallery__heading">
            {{ group[groupName] }}
          </h3>
        </slot>
      </div>
      <div>
        <div class="loader-bar" v-if="singleGallery && showLoaderFor === group.id"></div>
        <div class="loader-bar loader-bar--loop" v-else style="display: none;"></div>
        <div v-if="group.toolbar">
          <slot name="toolbar" :item="group"></slot>
        </div>
        <div class="mt-3"
             v-else-if="group[items] && group[items].includes(selected)">

          <slot name="toolbar" :selected="selected" :facility="group"></slot>
        </div>
        <draggable tag="ul"
                   :draggable="selector"
                   class="v-gallery__list"
                   v-model="group[items]"
                   v-bind="{ group: 'items', delay: 400, delayOnTouchOnly: true, touchStartThreshold: 3, fallbackTolerance: 3 }"
                   @update="$emit('reorder-item', group[items].map(i => i.id), group.id, galleryMemberId); $emit('reorder', reorder())"
                   @add="$emit('reorder-outer-item', group[items].map(i => i.id), group.id, galleryMemberId)"
                   @change="$event.removed || $event.added ? $emit('change', $event, group.id, galleryMemberId) : null">

          <template v-for="item in group[items]">
            <li class="v-gallery__item v-gallery__item--draggable"
                :class="{ 'v-gallery__item--is-selected': selected === item }"
                :key="item.id">
              <div class="v-gallery__holder">
                <div class="v-gallery__inner">
                  <slot :gallery-id="galleryMemberId" :item="item" :group="group" :groupheader="group[groupName]" :is-selected="selected === item"></slot>
                </div>
              </div>
              <v-lightcase-holder :image-src="item.url" :name="`lightcase-${item.id}`" :download-link="item.fileUrl" :current-document="item" :disable-rotate="disableRotate" :details="group"></v-lightcase-holder>
            </li>
          </template>
          <li :for="`file${group.id}`"
              class="v-gallery__item v-gallery__item-to-drop"
              v-if="!selected"
              @dragover="resetEvent($event)"
              @dragleave="resetEvent($event)"
              @drop="handleUpload($event, group.id, galleryMemberId)"
              @click="triggerFileInputClick(`fileInput${group.id}`)">
            <div class="v-gallery__holder">
              <div class="v-gallery__inner">
                <div class="v-gallery__plus">
                  +
                </div>
              </div>
            </div>
          </li>
          <li :for="`file${group.id}`"
              class="v-gallery__item v-gallery__item-to-drop"
              v-if="!selected"
              v-show="isMobile"
              @click="triggerFileInputClick(`cameraFileInput${group.id}`)">
            <div class="v-gallery__holder">
              <div class="v-gallery__inner">
                <div class="v-gallery__plus">
                  <i class="material-icons">party_mode</i>
                </div>
              </div>
            </div>
          </li>
        </draggable>
        <input type="file"
               @change="handleUpload($event, group.id, galleryMemberId)"
               accept="image/*"
               capture="camera"
               v-show="false"
               :ref="`cameraFileInput${group.id}`">
        <input type="file" v-if="acceptImages"
               multiple
               @change="handleUpload($event, group.id, galleryMemberId)"
               accept="image/*"
               v-show="false"
               :ref="`fileInput${group.id}`">
        <input type="file" v-else
               multiple
               @change="handleUpload($event, group.id, galleryMemberId)"
               v-show="false"
               :ref="`fileInput${group.id}`">

        
      </div>
      <div v-if="group.addForm" style="display: flex;">
        <slot name="add-form" :item="group"></slot>
      </div>
    </div>
  </draggable>
</template>

<script>
  import _ from "lodash";
  import MobileDetect from "mobile-detect/mobile-detect";
  import draggable from "vuedraggable";
  import "lightcase/src/css/lightcase.css";
  import configureLightcase from "../../lightcase.js";
  import VLightcaseHolder from "./VLightcaseHolder";
  import sweetalert from 'sweetalert';

  window.MobileDetect = MobileDetect;

  export default {
    components: {
      draggable,
      VLightcaseHolder
    },
    data() {
      return {
        selected: null,
        dataCollection: Object.assign([], this.collection),
        isDraggable: this.disableDragAndDrop ? '.none-of-current-items-draggable' : '.v-gallery__group',
        selector: window.app.methods.isTouchDevice() ? ".v-gallery__item--draggable" : ".v-gallery__item",
        selectorIsFiltered: window.app.methods.isTouchDevice() ? '.v-gallery__item-to-drop' : '',
        isMobile: false
      };
    },
    methods: {
      reorder() {
        return this.dataCollection.map(group => {
          let groupItems = {};
          groupItems[group.id] = group[this.items].map(i => i.id);
          return groupItems;
        });
      },
      toggleToolbar(groupId) {
        let currentGroupIndex = this.dataCollection.findIndex(item => {
          return item.id === groupId;
        });
        let currentGroup = this.dataCollection[currentGroupIndex];
        currentGroup.toolbar = !currentGroup.toolbar;
        this.dataCollection[currentGroupIndex] = {
          ...currentGroup
        };
        this.$emit("toolbar-toggled", {
          index: currentGroupIndex,
          state: !!currentGroup.toolbar
        });
        this.dataCollection = [...this.dataCollection];
      },
      toggleAddForm(groupId) {
        let currentGroupIndex = this.dataCollection.findIndex(item => {
          return item.id === groupId;
        });
        let currentGroup = this.dataCollection[currentGroupIndex];
        currentGroup.addForm = !currentGroup.addForm;
        this.dataCollection[currentGroupIndex] = {
          ...currentGroup
        };
        this.dataCollection = [...this.dataCollection];
      },
      resetEvent(event) {
        if (!window.app.methods.isTouchDevice()) {
          event.stopPropagation();
          event.preventDefault();
        }
      },
      triggerFileInputClick(ref) {
        this.$refs[ref][0].click();
      },
      handleUpload(event, groupId, galleryId) {
        event.preventDefault();
        event.stopPropagation();

        let files,
          filesNumber = 0;

        filesNumber = event.target.closest('.v-gallery__group-item').querySelectorAll('.v-gallery__item--draggable').length;

        if (
          event.dataTransfer &&
          event.dataTransfer.files &&
          event.dataTransfer.files.length
        )
        {
          files = event.dataTransfer.files;

          if (!this.allowSingleFileOnly) {
            this.$emit("upload", files, groupId, galleryId);
          }
          else {
            if (filesNumber === 0 && event.dataTransfer.files.length === 1) {
              this.$emit("upload", files, groupId, galleryId);
            } else {
              sweetalert('Information', 'You may upload only one file', 'info');
            }
          }
        } else if (
          event.target &&
          event.target.files &&
          event.target.files.length
        )
        {
          files = event.target.files;

          if (!this.allowSingleFileOnly) {
            this.$emit("upload", files, groupId, galleryId);
          }
          else {
            if (filesNumber === 0 && event.target.files.length === 1) {
              this.$emit("upload", files, groupId, galleryId);
            } else {
              sweetalert('Information', 'You may upload only one file', 'info');
            }
          }
        }
      }
    },
    props: {
      collection: {
        default: () => [],
        type: Array
      },
      galleryMemberId: {
        default: 0,
        type: Number
      },
      items: {
        default: "items",
        type: String
      },
      groupName: {
        default: "name",
        type: String
      },
      toolbar: {
        default: false,
        type: Boolean
      },
      addForm: {
        default: false,
        type: Boolean
      },
      editButton: {
        default: true,
        type: Boolean
      },
      removeButton: {
        default: true,
        type: Boolean
      },
      disableRotate: {
        default: false,
        type: Boolean
      },
      showLoaderFor: {
        default: 0,
        type: Number
      },
      disableDragAndDrop: {
        default: false,
        type: Boolean
      },
      acceptImages: {
        default: false,
        type: Boolean
      },
      singleGallery: {
        default: true,
        type: Boolean
      },
      allowSingleFileOnly: {
        default: false,
        type: Boolean
      },      
    },
    created() {
      var md = new MobileDetect(window.navigator.userAgent);
      if (md.mobile() !== "" && md.mobile() !== null) {
        this.isMobile = true;
      }
      if (!this.singleGallery) {
        $(document).on('click', '.v-gallery__plus', function () {
          $('.loader-bar--loop').removeClass('is-visible');
          $(this).parents('.v-gallery__group-item').find('.loader-bar--loop').addClass('is-visible');
        });
      }
    },
    watch: {
      collection(value) {
        this.dataCollection = value;
      }
    },
    beforeMount() {      
      configureLightcase();
    },
    beforeUpdate() {
      configureLightcase();
    },
    updated() {
      this.$root.$emit("galleryUpdated");
    }
  };
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/VGallery.vue